export default __webpack_public_path__ + "static/media/306.956f1180.png";